import { COLOR_BLIND_MODE, DARK_MODE, LIGHT_MODE } from './variants';

export const ReemaThemeV2 = {
  LIGHT_MODE,
  DARK_MODE,
  COLOR_BLIND_MODE,
};
